import request from '@/utils/request'

// 获取首页数据
export const getShopData = () => {
  return request({
    url: '/erp/mshop/index',
    method: 'get'
  })
}

// 修改店铺信息
export const setShopName = (data) => {
  return request({
    url: '/erp/mshop/edit',
    method: 'post',
    data
  })
}

// 我的店铺列表
export const myShopList = (data) => {
  return request({
    url: '/erp/mshop/my-mshop',
    method: 'get',
    data
  })
}

// 切换店铺
export const myShopChange = (data) => {
  return request({
    url: '/erp/mshop/replace-mshop',
    method: 'post',
    data
  })
}